module.exports = __webpack_public_path__ + "static/media/dead_battery_sel.f647be41.svg";